import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/Global.css';
import Layout from './components/Layout/Layout';
import PrivateRoute from './components/auth/PrivateRoute';
import Sidebar from './components/Layout/Sidebar';
import Home from './pages/Home';
import Locations from './pages/Configs/Locations';
import ItemUnits from './pages/Configs/ItemUnits';
import AddUnitsModal from './components/Configs/AddUnitsModal';
import EditUnitsModal from './components/Configs/EditUnitsModal';
import ItemCategories from './pages/Configs/ItemCategories';
import ItemStatusList from './pages/Configs/ItemStatusList';
import ItemFolios from './pages/Configs/ItemFolios';
import Inventory from './pages/Items/Inventory';
import Users from './pages/Users/Users';
import Login from './pages/Login';
import LoginLogs from './pages/Users/LoginLogs';
import RequestRecoverPassword from './pages/RequestRecoverPassword';
import ResetPassword from './pages/ResetPassword';
import Reports from './pages/Reports/Reports';
import Docs from './pages/Docs';
import SupplyInventory from './pages/Supplies/SupplyInventory';
import SuppliesReports from './pages/Supplies/SuppliesReports';
import ExcelReports from './pages/Excel/ExcelReports';
import InventoryReconciliation from './pages/Excel/InventoryReconciliation';

const AppTree = (
  <>
    <ToastContainer newestOnTop closeOnClick={false} />
    <Router>
      <Routes>
        <Route path="/" element={
          <PrivateRoute>
            <Layout >
              <Home />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/locations" element={
          <PrivateRoute>
            <Layout routes={[{
              name: "Inicio",
              url: "/",
              isActive: false
            }, {
              name: "Ubicaciones",
              url: "/locations",
              isActive: true
            }]} >
              <Locations />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/itemCategories" element={
          <PrivateRoute>
            <Layout routes={[{
              name: "Inicio",
              url: "/",
              isActive: false
            }, {
              name: "Categorías",
              url: "/categories",
              isActive: true
            }]} >
              <ItemCategories />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/itemStatus" element={
          <PrivateRoute>
            <Layout routes={[{
              name: "Inicio",
              url: "/",
              isActive: false
            }, {
              name: "Estados",
              url: "/status",
              isActive: true
            }]} >
              <ItemStatusList />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/inventory" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Inventario", url: "/inventory", isActive: true },
            ]} fluid={true} >
              <Inventory />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/supplies" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Consumibles", url: "/supplies", isActive: true },
              { name: "Agregar consumible", url: "/addsupplies", isActive: false }
            ]} fluid={true} >
              <SupplyInventory />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/suppliesreports" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Reporte de Consumibles", url: "/suppliesreports", isActive: true }]}>
              <SuppliesReports />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/users" element={
          <PrivateRoute>
            <Layout routes={[{
              name: "Inicio",
              url: "/",
              isActive: false
            }, {
              name: "Usuarios",
              url: "/users",
              isActive: true
            }, {
              name: "Agregar usuario",
              url: "/AddUser",
              isActive: false
            }]} >
              <Users />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/loginlogs" element={
          <PrivateRoute>
            <Layout routes={[{
              name: "Inicio",
              url: "/",
              isActive: false
            }]} >
              <LoginLogs />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/reports" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Reportes", url: "/Reports", isActive: true }]}>
              <Reports />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/folios" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Folios", url: "/folios", isActive: true }
            ]} >
              <ItemFolios />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/docs" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Documentación", url: "/docs", isActive: true }
            ]}>
              <Docs />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/itemUnits" element={
          <PrivateRoute>
            <Layout routes={[{
              name: "Inicio",
              url: "/",
              isActive: false
            }, {
              name: "Unidades de Medida",
              url: "/itemUnits",
              isActive: true
            }]} >
              <ItemUnits />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/addunitsmeasure" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Unidad de Medida", url: "/itemUnits", isActive: false },
              { name: "Agregar unidad de medida", url: "#", isActive: true }
            ]} >
              <AddUnitsModal />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/editunitsmeasure/:id" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Unidad de Medida", url: "/itemUnits", isActive: false },
              { name: "Editar unidad de medida", url: "#", isActive: true }
            ]} >
              <EditUnitsModal />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/excel-reports" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Importación de Excel", url: "/excel-reports", isActive: true }
            ]}>
              <ExcelReports />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/inventory-reconciliation" element={
          <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false },
              { name: "Conciliación de Inventario", url: "/inventory-reconciliation", isActive: true }
            ]}>
              <InventoryReconciliation />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/login" element={<Login />} />
        <Route path="/requestRecoverPassword" element={<RequestRecoverPassword />} />
        <Route path="/ResetPassword/:id" element={<ResetPassword />} />

      </Routes>
    </Router>
  </>
  // </React.StrictMode >
);

// Silenciar errores benignos del ResizeObserver
const swallowROError = (event) => {
  const msg = event?.message || event?.reason?.message || "";
  if (
    msg.includes("ResizeObserver loop completed with undelivered notifications") ||
    msg.includes("ResizeObserver loop limit exceeded")
  ) {
    event.preventDefault(); // Evita que se loguee en consola
    return false;
  }
};

window.addEventListener("error", swallowROError);
window.addEventListener("unhandledrejection", swallowROError);

const root = createRoot(document.getElementById('root'));

const isDev = process.env.NODE_ENV !== 'production';

// En desarrollo: SIN StrictMode (evita el loop de ResizeObserver)
// En producción: CON StrictMode
if (isDev) {
  root.render(AppTree);
} else {
  root.render(<React.StrictMode>{AppTree}</React.StrictMode>);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
